import React, { Fragment } from "react";
import LiveLinkRequestUserItem from "./LiveLinkRequestUserItem";

const LiveLinkRequests = ({ liveLinks, setParticipant, removeRequest }) => {
  return (
    <Fragment>
      <div className="side-container border-right grey">
        <div className="online-title-container-alt">
          <div className="border-alt red">
            <p className="online-title-alt red">
              <i className="fas fa-link red mr-5"></i>Live Link
            </p>
          </div>
        </div>
        <div className="all-users">
          {liveLinks && liveLinks.length > 0 ? (
            liveLinks.map((user) => {
              return (
                <LiveLinkRequestUserItem
                  key={user.channelid}
                  user={user}
                  removeRequest={removeRequest}
                  setParticipant={setParticipant}
                />
              );
            })
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark red bold">No Requests</p>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default LiveLinkRequests;
